import { render, staticRenderFns } from "./otp_list.vue?vue&type=template&id=23bdc1a7&"
import script from "./otp_list.vue?vue&type=script&lang=js&"
export * from "./otp_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports